module.exports = __webpack_public_path__ + "static/media/maroon-tape.af79c9dc.png";